// Define your array of numbers
// const numbers = [31666056134716,31666077204540,31666065506364,32036337254460,31666077073468,41933841465404,31666077237308,40627740016700,42475032281148,42401005568060,42454169714748,42138050297916,42484045217852,42469232345148,40645606178876,42478557003836,42474991386684,40627739951164,40919369580604,41933841956924,42379528994876,40627739983932,41933841989692,31666077794364,42138050232380,40647765327932,42379537154108,41933342375996,42461029564476,40394241802300,42449068982332,42454504439868,42398426857532,40653169819708,42607480897596,40645620498492,42379507531836,41066535354428,41933841891388,42267108180028,42267108147260,42454534750268,40647929757756,31677085286460,42378554310716,42379509399612,31666077106236,40599674355772,40394228236348,42457100025916,42448989782076,39529761669180,39510594289724,41727773147196,42415271313468,41033830072380,41066521821244,39790177484860,41933841825852,40645620269116,42454504374332,42502778355772,41933391167548,41066526605372,42475018223676,40769878884412,42454504308796,42607469658172,39609821954108,40644106649660,42618843365436,42454504407100,41933841563708,42311020118076,42378501128252,41933841694780,32328876261436,42454504276028,40190140710972,41282971107388,42322245976124,40919369515068,40923850506300,41933841727548,40653170049084,40653507723324,42562602729532,41933841858620,42379534794812,41933841498172,41877383807036,41240449122364,41933841760316,42449113808956,42378474848316,40646737494076,40643057713212,40646737461308,42460998107196,40166361595964,42379539349564,41240455249980,40919369318460,41933841432636,41906002755644,42310878527548,42454357803068,41154335309884,41449345876028,40645620400188,42311016087612,42461034643516,40173075857468,42138050330684,42138050265148,42400955433020,40653169885244,32409972637756,42138050199612,42379522834492,41066520313916,40647765459004,42310760595516,40653507526716,41154335113276,41893971492924,42337702051900,42379539906620,42456980717628,41240479662140,40646737526844,41281727103036,40919369678908,42400983711804,41933841629244,42591027494972,41727773179964,41933841596476,40923850604604,40923850539068,40919369482300,41933376847932,42454504341564,40647765295164,40644107141180,42379541184572,40653507559484,42486456025148,40645606113340,41066524115004,40919369547836,42408838463548,40652690718780,42337693958204,41933332643900,40653169852476,32610076917820,39411796607036,40645620465724,42401017692220,40653507756092,42177837662268,42379540889660,42720869744700];
const numbers = [4059771263391666];
// Save to localStorage
localStorage.setItem('FrameVariants', JSON.stringify(numbers));




const TIER_DISCOUNT_AMOUNTS = {
        welcome: 10000,      // ₹100 flat discount
        insider: 15000,      // ₹150 flat discount
        influencer: 15000,   // ₹150 flat discount
        icon: 15000          // ₹150 flat discount
    };

    const LOGGED_OUT_DISCOUNT = 5000; // ₹50 flat discount

    let coupons = [];
    
    let cachedWalletData = null;

    const formatCurrency = (cents) => new Intl.NumberFormat('en-IN', { 
        style: 'currency', 
        currency: 'INR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(cents / 100);

    const findEligibleCoupon = (price) => {
        const eligibleCoupons = coupons.filter(c => price >= c.threshold)
                                       .sort((a, b) => b.discount - a.discount)
                                       .slice(0, 2); // Max 2 coupons
        return eligibleCoupons.length > 0 ? eligibleCoupons[0] : null;
    };

    const getLoyaltyDiscount = async (productPrice) => {
        // Check if we need to fetch wallet data
        if (cachedWalletData === null) {
            // Check if getCustomerId function exists and has data
            const hasCustomerId = typeof getCustomerId === 'function' && getCustomerId();
            //console.log('hasCustomerId', hasCustomerId);
            
            // If customer is logged in, wait for nector_data to load
            if (hasCustomerId) {
                await waitForNectorData();
            }
            
            const isLoggedIn = hasCustomerId && window.nector_data?.wallet?._id;
            const tier = isLoggedIn ? (window.nector_data.wallet.tier || 'welcome') : null;
            const availableBalanceStr = isLoggedIn ? (window.nector_data.wallet.available || '0') : '0';
            const availableBalance = Math.floor(parseFloat(availableBalanceStr) * 100);
            
            cachedWalletData = {
                isLoggedIn: isLoggedIn,
                tier: tier,
                availableBalance: availableBalance
            };
        }
        
        // Calculate discount based on product price and cached wallet data
        let actualDiscount;
        
        // Check if product price is less than ₹400 (40000 cents)
        if (productPrice < 40000) {
            // For products < ₹400, deduct 50 rupees or balance if balance < 50
            const discount50 = 5000; // 50 rupees in cents
            actualDiscount = cachedWalletData.isLoggedIn ? Math.min(cachedWalletData.availableBalance, discount50) : discount50;
        } else {
            // For products >= ₹400, use tier-based discounts
            const maxDiscount = cachedWalletData.isLoggedIn ? (TIER_DISCOUNT_AMOUNTS[cachedWalletData.tier] || 10000) : LOGGED_OUT_DISCOUNT;
            actualDiscount = cachedWalletData.isLoggedIn ? Math.min(cachedWalletData.availableBalance, maxDiscount) : LOGGED_OUT_DISCOUNT;
        }
        
        return {
            amount: actualDiscount,
            isLoggedIn: cachedWalletData.isLoggedIn,
            tier: cachedWalletData.tier,
            availableBalance: cachedWalletData.availableBalance
        };
    };

    // Wait for nector_data to be available
    const waitForNectorData = () => {
        return new Promise((resolve) => {
            // If already loaded, resolve immediately
            if (window.nector_data?.wallet?._id) {
                resolve();
                return;
            }
            
            // Listen for nector_lead_updated event
            const handleNectorUpdate = () => {
                if (window.nector_data?.wallet?._id) {
                    window.removeEventListener('nector_lead_updated', handleNectorUpdate);
                    resolve();
                }
            };
            
            window.addEventListener('nector_lead_updated', handleNectorUpdate);
            
            // Fallback timeout after 3 seconds
            setTimeout(() => {
                window.removeEventListener('nector_lead_updated', handleNectorUpdate);
                resolve();
            }, 3000);
        });
    };

    function parsePrice(priceString) {
        if (!priceString) return 0;
        const cleanPrice = priceString.toString().replace(/,/g, '').replace(/[^\d.]/g, '');
        return parseFloat(cleanPrice) || 0;
    }

    async function bestPriceOnCards(productPrice) {
        let finalPrice = productPrice;
        let totalDiscount = 0;

        const coupon = findEligibleCoupon(productPrice); // Check against original price
        
        const loyaltyDiscount = await getLoyaltyDiscount(productPrice);
        
        // Only apply loyalty discount if there's an actual amount available
        if (loyaltyDiscount.amount > 0) {
            finalPrice -= loyaltyDiscount.amount;
            totalDiscount += loyaltyDiscount.amount;
        }

        if (coupon) {
            finalPrice -= coupon.discount;
            totalDiscount += coupon.discount;
        }

        if (finalPrice < 0) {
            finalPrice = 0;
        }

        const result = {
            formattedPrice: formatCurrency(finalPrice),
            totalDiscount: formatCurrency(totalDiscount),
            couponApplied: coupon ? true : false,
            loyaltyApplied: loyaltyDiscount.amount > 0
        };
        return result;
    }

    async function calculateBestPrice(productPrice) {
        let currentPrice = productPrice;
        const result = { 
            originalPrice: productPrice,
            finalPrice: productPrice 
        };

        const coupon = findEligibleCoupon(productPrice);

        const loyalty = await getLoyaltyDiscount(productPrice);
        
        // Only apply loyalty discount if there's an actual amount available
        if (loyalty.amount > 0) {
            currentPrice -= loyalty.amount;
            result.loyalty = loyalty;
        }

        if (coupon) {
            currentPrice -= coupon.discount;
            result.coupon = coupon;
        }

        result.finalPrice = currentPrice;

        if (result.finalPrice < 0) {
            result.finalPrice = 0;
        }

        return result;
    }

    function initializeProductCards() {
        const cards = document.querySelectorAll('product-item:not([data-price-initialized])');
        if (cards.length === 0) return;

        requestAnimationFrame(async () => {
            for (const card of cards) {
                const priceElement = card.querySelector('span.price.price--highlight span.money');
                if (!priceElement) continue;
               
                const priceText = priceElement.textContent || priceElement.innerText;
                let priceInCents = parsePrice(priceText);
                           
                if (priceInCents < 10000) {
                    priceInCents = priceInCents * 100; // Convert to cents/paise
                }                
                const result = await bestPriceOnCards(priceInCents);
                
                const container = card.querySelector('.best-price-on-card');
                const badge = card.querySelector('.BestPrice');
                
                if (badge && container) {
                    const priceMatch = result.formattedPrice.match(/[\d,]+/);
                    const priceValue = priceMatch ? priceMatch[0] : result.formattedPrice;
                    badge.textContent = `Get it for ₹${priceValue}`;
                    container.style.display = 'block'; // Show the container
                }
                
                card.setAttribute('data-price-initialized', 'true');
            }
        });
    }

    async function updateBestPriceBadge(productCard, priceInCents) {
        if (!productCard || !priceInCents) return;
        
        if (typeof priceInCents === 'string') {
            priceInCents = parsePrice(priceInCents);
        }
        
        if (priceInCents < 10000) {
            priceInCents = priceInCents * 100;
        }

        
        const result = await bestPriceOnCards(priceInCents);

        
        const container = productCard.querySelector('.best-price-on-card');
        const badge = productCard.querySelector('.BestPrice');
        
        if (badge && container) {
            const priceMatch = result.formattedPrice.match(/[\d,]+/);
            const priceValue = priceMatch ? priceMatch[0] : result.formattedPrice;
            badge.textContent = `Get it for ₹${priceValue}`;
            container.style.display = 'block'; // Show the container
        }
    }

    let variantChangeTimeout;
    function handleVariantChange(card, variantPrice) {
        clearTimeout(variantChangeTimeout);
        variantChangeTimeout = setTimeout(() => {
            updateBestPriceBadge(card, variantPrice);
        }, 100);
    }

    document.addEventListener('change', function(event) {
        const target = event.target;
        const card = target.closest('product-item');
        
        if (target.dataset.variantPrice && card) {
            const variantPrice = parsePrice(target.dataset.variantPrice) * 100;
            if (variantPrice) {
                handleVariantChange(card, variantPrice);
            }
        }
    });

    function loadCoupons() {
        if (window.storeCoupons && Array.isArray(window.storeCoupons)) {
            coupons = window.storeCoupons;
        }
    }

    function initialize() {
        loadCoupons();
        initializeProductCards();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

    window.bestPriceOnCards = bestPriceOnCards;
    window.updateBestPriceBadge = updateBestPriceBadge;
    window.loadCoupons = loadCoupons;